import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

// The app runs even before you've added your keys — auth/data calls will show a
// friendly "backend not configured" message instead of crashing. Fill in
// .env.local (see .env.example) and restart `npm run dev` to connect.
export const isConfigured = Boolean(url && anonKey)

// Supabase's realtime client wants a global WebSocket at construction time. The
// browser has one; Node < 22 (our SSG build host) does not, which would crash
// prerendering. We never use realtime, so when no native WebSocket exists we hand
// it a harmless stub transport — it's only constructed here, never connected.
const realtimeOpts =
  typeof WebSocket === 'undefined' ? { realtime: { transport: class {} } } : {}

export const supabase = isConfigured
  ? createClient(url, anonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
      ...realtimeOpts,
    })
  : null

if (!isConfigured) {
  // eslint-disable-next-line no-console
  console.warn(
    '[PeptideCalc] Supabase is not configured. Copy .env.example to .env.local, ' +
      'add your project URL and anon key, then restart the dev server.'
  )
}
